// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"4762f53b","195":"93749249","243":"1059cff1","408":"e6148f56","965":"15f4cb35"}[chunkId] + ".chunk.css";
};